"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import type { ImpressionMetadata } from "@/lib/discovery/impression-client";
import { observeDiscoveryImpression } from "@/lib/discovery/impression-observer";

/** Invisible marker observes its existing card root; adds no layout wrapper. */
export function DiscoveryImpression({
  entityType,
  entityId,
  surface,
  token,
}: ImpressionMetadata) {
  const marker = useRef<HTMLSpanElement>(null);
  const pathname = usePathname();
  const originalPath = useRef(pathname);
  useEffect(() => {
    if (pathname !== originalPath.current) return;
    const card = marker.current?.parentElement;
    if (card)
      return observeDiscoveryImpression(card, {
        entityType,
        entityId,
        surface,
        token,
      });
  }, [entityType, entityId, surface, token, pathname]);
  return <span ref={marker} hidden aria-hidden="true" />;
}
